import { Component, OnInit } from "@angular/core";
import { Router, NavigationEnd } from "@angular/router";
import { UserSettingDataService } from "./service/userSettingDataService/userSettingData.service";

@Component({
  // tslint:disable-next-line
  selector: "app-root",
  template: "<router-outlet></router-outlet>",
})
export class AppComponent implements OnInit {
  constructor(
    private router: Router,
    private userSettingService: UserSettingDataService,
  ) {
    if (sessionStorage.getItem("invUIToken")) {
      this.userSettingService.fetchUserSettings();
    }
  }

  ngOnInit() {
    // if (
    //   sessionStorage.getItem("invUIToken") == null ||
    //   sessionStorage.getItem("invUIToken") == "" ||
    //   sessionStorage.getItem("invUIToken") == undefined
    // ) {
    //   this.router.navigate(["/login"]);
    // }
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });
  }
}
